import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { useState } from "react"
import type { EmailVerifierResult } from "../../components/emailVerifier"

export function useBulkEmailVerifier() {
  const [results, setResults] = useState<EmailVerifierResult[]>([])

  const mutation = useMutation({
    mutationFn: async (emails: string[]) => {
      const response = await axios.post<{
        data: EmailVerifierResult[]
      }>("/backoffice/emailVerifier/verify", { emails })
      return response.data.data
    },
    onSuccess: (data) => {
      setResults(data)
    },
    onError: () => {
      setResults([])
    },
  })

  const verifyEmails = (emails: string[]) => {
    setResults([]) // Clear previous results
    mutation.mutate(emails)
  }

  return {
    verifyEmails,
    isLoading: mutation.isPending,
    results,
    error: mutation.error?.message || null,
  }
}
